import React, { ChangeEvent, FocusEvent, FormEvent } from 'react';
import { SUCCEESS_MODAL_PROPS, SuccessModal } from '../../../Ui/SuccessModal';
import { FORM_DATA } from './Utils/types';
import { WebinarForm } from './WebinarForm';

interface WebinarLeadFormProps {
  formTitle: string;
  buttonText: string;
  onClick?: () => void;
  successData: SUCCEESS_MODAL_PROPS;
  formSuccess: boolean;
  onTextChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onSubmitForm: (e: FormEvent) => void;
  onBlurField: (e: FocusEvent<HTMLInputElement, Element>) => void;
  formData: Record<string, FORM_DATA>;
  isFormSubmitting: boolean;
}
export const WebinarLeadFormCondition = ({
  formTitle,
  buttonText,
  successData,
  formSuccess,
  onTextChange,
  onSubmitForm,
  onBlurField,
  formData,
  isFormSubmitting,
}: WebinarLeadFormProps): JSX.Element => {
  return (
    <div>
      {!formSuccess ? (
        <div className="px-6 py-4 sm:px-0 sm:py-2">
          <div id="ksa-einvoicing-modal-wrapper">
            <div className="text-center text-s-24 text-font-500 font-bold pb-8 sm:text-base sm:pb-4">
              {formTitle}
            </div>

            <WebinarForm
              onTextChange={onTextChange}
              onSubmitForm={onSubmitForm}
              onBlurField={onBlurField}
              formData={formData}
              buttonText={buttonText}
              isFormSubmitting={isFormSubmitting}
            />
          </div>
        </div>
      ) : (
        <div id="ksa-einvoicing-success-wrapper" className="text-center my-0">
          <SuccessModal
            title={successData.title}
            desc={successData.desc}
            icon={successData.icon}
            buttonText={successData.buttonText}
            buttonFn={successData.buttonFn}
          />
        </div>
      )}
    </div>
  );
};
